function Logo({className}: {className?: string}) {
  return (
    <svg
      viewBox="0 0 36 36"
      className={`${className} transition-all duration-300 hover:rotate-180`}
    >
      <path
        fill="var(--foreground)"
        d="M25.8 16.1 33 12c.9-.5 1.4-1.7.9-2.7s-1.8-1.5-2.8-.9l-7.3 4.1 4.1-7.1c.5-.9.4-2.2-.5-2.8s-2.3-.4-2.9.6l-4.1 7.2V2.2c0-1.1-.8-2.1-1.8-2.2s-2.2.8-2.2 2v8.3l-4.1-7.1c-.5-.9-1.7-1.4-2.7-.9s-1.5 1.8-.9 2.8l4.1 7.2-7.2-4.1c-.9-.5-2.2-.4-2.8.5s-.4 2.3.6 2.9l7.3 4.1H2.2c-1.1.1-2.1.9-2.2 1.9s.8 2.2 2 2.2h8.4l-7.2 4.1c-.9.5-1.4 1.7-.9 2.7s1.8 1.5 2.8.9l7.3-4.1-4.1 7.1c-.5.9-.4 2.2.5 2.8s2.3.4 2.9-.6l4.1-7.2v8.2c0 1.1.8 2.1 1.8 2.2s2.2-.8 2.2-2v-8.3l4.1 7.1c.5.9 1.7 1.4 2.7.9s1.5-1.8.9-2.8l-4.1-7.2 7.2 4.1c.9.5 2.2.4 2.8-.5s.4-2.3-.6-2.9l-7.3-4.1h8.4c1.2 0 2.1-1 2-2.2s-1.1-1.8-2.2-1.8h-8Z"
      />
    </svg>
  );
}

export {Logo};
